import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface GameEasterEggPayload extends EventPayload {
  game: {
    playTime: number;
  };
  content: {
    title: string;
  };
}

const GameEasterEggViewedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.lowPoly,
  eventName: "Game Easter Egg Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGameEasterEggViewedPageEventPayload =
  eventPagePayloadCreator<GameEasterEggPayload>(
    GameEasterEggViewedAnalyticsEvent,
  );
